import { render, staticRenderFns } from "./BtnAtualizarItemContrato.vue?vue&type=template&id=28f24df0"
import script from "./BtnAtualizarItemContrato.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarItemContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports